export enum SelectionModeTypes {
  SINGLE_SELECT = "singleselect",
  MULTI_SELECT = "multiselect"
}
